// Removes a leading /ro or /ru locale segment so the webchat backend sees the
// logical page (e.g. /ru/configurator -> /configurator). The lookahead keeps
// paths like /router or /rooms intact.
export function stripLocale(pathname: string): string {
  const p = pathname.replace(/^\/(ro|ru)(?=\/|$)/, '')
  return p === '' ? '/' : p
}
